import { useState } from "react";
import Reveal from "@/components/Reveal";

const categories = ["All", "Civil Work", "Interiors", "Modular Kitchens", "Restoration"];

const projects = [
  {
    name: "Contemporary Residence",
    location: "Bandra West, Mumbai",
    type: "Interiors",
    img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80",
    alt: "Modern residential interior living space in Bandra West Mumbai",
  },
  {
    name: "Structural Civil Works",
    location: "Andheri East, Mumbai",
    type: "Civil Work",
    img: "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?auto=format&fit=crop&w=1200&q=80",
    alt: "Concrete civil construction and masonry work in Andheri Mumbai",
  },
  {
    name: "Lakeview Modular Kitchen",
    location: "Powai, Mumbai",
    type: "Modular Kitchens",
    img: "https://images.unsplash.com/photo-1663811396777-05505d999151?auto=format&fit=crop&w=1200&q=80",
    alt: "Luxury modular kitchen with smart storage in Powai Mumbai",
  },
  {
    name: "Heritage Home Restoration",
    location: "Dadar, Mumbai",
    type: "Restoration",
    img: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?auto=format&fit=crop&w=1200&q=80",
    alt: "Restored premium living room in a heritage Mumbai home",
  },
  {
    name: "Minimal Living Space",
    location: "Juhu, Mumbai",
    type: "Interiors",
    img: "https://images.unsplash.com/photo-1601993957728-1e56ab70c5a8?auto=format&fit=crop&w=1200&q=80",
    alt: "Minimalist staircase and interior finishing in Juhu Mumbai",
  },
  {
    name: "Compact Modular Kitchen",
    location: "Thane, Mumbai",
    type: "Modular Kitchens",
    img: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?auto=format&fit=crop&w=1200&q=80",
    alt: "Compact modern modular kitchen installation in Thane",
  },
  {
    name: "Flooring & Masonry Package",
    location: "Chembur, Mumbai",
    type: "Civil Work",
    img: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=1200&q=80",
    alt: "Civil flooring and masonry execution site in Chembur Mumbai",
  },
  {
    name: "Office Space Renovation",
    location: "Lower Parel, Mumbai",
    type: "Restoration",
    img: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=80",
    alt: "Renovated modern office space interior in Lower Parel Mumbai",
  },
];

export default function Projects() {
  const [active, setActive] = useState("All");
  const filtered = active === "All" ? projects : projects.filter((p) => p.type === active);

  return (
    <section id="projects" data-testid="projects-section" className="py-24 lg:py-32 bg-zinc-50 border-y border-zinc-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <Reveal className="max-w-2xl">
            <p className="text-xs tracking-[0.25em] uppercase font-semibold text-zinc-500 mb-5">04 &middot; Portfolio</p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-zinc-950">
              Selected Work
            </h2>
          </Reveal>
          <div className="flex flex-wrap gap-2" data-testid="project-filters">
            {categories.map((c) => (
              <button
                key={c}
                data-testid={`project-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setActive(c)}
                className={`text-xs font-semibold tracking-wide px-5 py-2.5 border rounded-sm transition-colors duration-300 ${
                  active === c
                    ? "bg-zinc-950 text-white border-zinc-950"
                    : "bg-white text-zinc-600 border-zinc-200 hover:border-zinc-950 hover:text-zinc-950"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {filtered.map((p, i) => (
            <Reveal key={p.name} delay={(i % 2) * 0.1}>
            <figure data-testid={`project-card-${p.name.toLowerCase().replace(/[\s&]+/g, "-")}`} className="group">
              <div className="overflow-hidden rounded-sm border border-zinc-200 aspect-[4/3]">
                <img
                  src={p.img}
                  alt={p.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
              </div>
              <figcaption className="mt-5 flex items-start justify-between gap-4">
                <div>
                  <h3 className="font-heading text-lg font-medium text-zinc-950">{p.name}</h3>
                  <p className="mt-1 text-sm text-zinc-500">{p.location}</p>
                </div>
                <span className="text-xs font-semibold tracking-wide uppercase text-zinc-500 border border-zinc-200 rounded-sm px-3 py-1.5 whitespace-nowrap">
                  {p.type}
                </span>
              </figcaption>
            </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
